export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function getHeaderOffset(defaultOffset = 88): number {
  const nav = typeof document !== 'undefined' ? document.querySelector('nav') as HTMLElement | null : null;
  const h = nav?.offsetHeight || defaultOffset;
  // Add a small margin for mobile browser UI
  return h + 8;
}

export function scrollToElement(target: HTMLElement, options?: { offset?: number; behavior?: ScrollBehavior }): void {
  const offset = options?.offset ?? getHeaderOffset();
  const reduce = prefersReducedMotion();
  const behavior: ScrollBehavior = reduce ? 'auto' : (options?.behavior ?? 'smooth');

  const rect = target.getBoundingClientRect();
  const absoluteY = rect.top + window.scrollY - offset;
  window.scrollTo({ top: absoluteY, behavior });
}

export function focusInto(target: HTMLElement, focusSelector?: string): void {
  let elToFocus: HTMLElement | null = null;
  if (focusSelector) {
    elToFocus = target.querySelector(focusSelector) as HTMLElement | null;
  }
  if (!elToFocus) {
    // try first heading or first form control
    elToFocus = (target.querySelector('h1, h2, h3, input, select, textarea, button, [tabindex]') as HTMLElement) || null;
  }
  if (!elToFocus) {
    elToFocus = target;
  }
  const prevTabIndex = elToFocus.getAttribute('tabindex');
  if (!elToFocus.hasAttribute('tabindex')) elToFocus.setAttribute('tabindex', '-1');
  elToFocus.focus({ preventScroll: true });
  // clean up temporary tabindex if it was added
  if (prevTabIndex === null) {
    elToFocus.addEventListener('blur', () => {
      elToFocus && elToFocus.removeAttribute('tabindex');
    }, { once: true });
  }
}

export function scrollAndFocus(targetEl: HTMLElement | null, opts?: { hash?: string; focusSelector?: string; announce?: (msg: string) => void; message?: string; behavior?: ScrollBehavior; offset?: number; pushState?: boolean; }): void {
  if (!targetEl) return;
  scrollToElement(targetEl, { behavior: opts?.behavior, offset: opts?.offset });
  focusInto(targetEl, opts?.focusSelector);
  if (opts?.hash) {
    try {
      if (opts?.pushState) {
        history.pushState(null, '', opts.hash);
      } else {
        history.replaceState(null, '', opts.hash);
      }
    } catch {
      // ignore
    }
  }
  if (opts?.announce && opts?.message) {
    opts.announce(opts.message);
  }
}
